import type { PortalAudience } from '@/access/portalAccess.types';
import type { ClientUsersViewInput } from '@/modules/clientUsers/clientUsers.viewInput';

export type ClientUsersView = {
  audience: PortalAudience;
  actions: {
    showInvite: boolean;
    showRevoke: boolean;
  };
  query: {
    users: { fetch: boolean };
    invites: { fetch: boolean };
    sites: { fetch: boolean };
  };
};

export const getClientUsersView = ({
  access,
}: ClientUsersViewInput): ClientUsersView => {
  const { audience } = access;

  return {
    audience,
    actions: {
      showInvite: true, // show the invite button to the client AND the tenant for now.
      showRevoke: true, // show the revoke action to the client AND the tenant for now.
    },
    query: {
      users: { fetch: true },
      invites: { fetch: true },
      sites: { fetch: true },
    },
  };
};
